// import {WOW} from 'wowjs';
// import {tns} from 'tiny-slider';

'use strict'


import WhatsApp from './lib/WhatsApp';

$.var = function(name, value) {
  if(name instanceof Object){
    for(let n in name){
      $('*[data-var="' + n + '"]').html(name[n]);
    }
    return;
  }
  return $('*[data-var="' + name + '"]').html(value);
};
$.fn.extend({
  loading: function() {
    this.addClass('btn--loading');
  },
  finish: function() {
    this.removeClass('btn--loading');
  }
});

class App {

    constructor() {
      let BASE_URL = App.baseUrl;
      $.ajaxSetup({cache: false});
      $(document).ajaxSuccess(function( event, request, settings ) {
        let data = request.responseJSON;
        if (data && data.status === 0 && data.hasOwnProperty('message')){
          $('.global-error').text(data.message).show();
        }
        if (data && data.status === 3){
          window.location = BASE_URL + '/panel/login';
        }
      });
      $('select').each(function(){
        $(this).selectric({
            arrowButtonMarkup: '<i class="select-arrow"></i>',
            onClose: function() {
              $(this).closest('.form-group').addClass('focused');
            },
            onChange: function() {
              $(this).change();
              if ($(this).val()=='' || $(this).val()==null) {
                  $(this).closest('.selectric-wrapper').addClass('placeholder');
                } else {
                  $(this).closest('.selectric-wrapper').removeClass('placeholder');
                }
              }
            });
        if($(this).val()=='' || $(this).val()==null){
          $(this).closest('.selectric-wrapper').addClass('placeholder');
        }
      });

      $('.form-control').focus(function(){
        $(this).parents('.form-group').addClass('focused');
      });
      $('.ic-eye').click(function(e){
        if ($(this).hasClass('active')){
          $(this).parent().find('input[type="text"]').attr('type', 'password');
          $(this).removeClass('active');
        } else {
          $(this).parent().find('input[type="password"]').attr('type', 'text');
          $(this).addClass('active');
        }
      });
      $('#mobileMenu').on('click', function() {

        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $('body').removeClass('menu-mobile-opened');
        } else {
          $(this).addClass('active');
          $('body').addClass('menu-mobile-opened');
        }
      });
      //if(!$('#mobileMenu').is(":visible")){
        $('.contact__whatsapp').on('click', function (e){
          e.preventDefault();
          WhatsApp.open($(this).text().replace(/\s/g, ''), 'Me interesa recibir más información sobre AFAP Itaú. https://www.afapitau.com.uy');
        });
      //} else {
      //  $('.contact__whatsapp').each(function(){
      //    let tel = $(this).attr('href').replace('tel:', '');
      //    $(this).attr('href', "whatsapp://" + tel);
      //  });
      //}
      if ($('.box_account_email').length > 0) {
        if (!sessionStorage.getItem('modal_account_item') || sessionStorage.getItem('modal_account_item') != 'false' ) {
            $('.box_account_email').removeClass('d-none');
        }
      }

      $('.article-box__close').on('click', function(e) {
        e.preventDefault();

        sessionStorage.setItem('modal_account_item', 'false');

        $(this).closest('.article-box').addClass('article-box--hide');
      });

      // Modal close
      $('.modal__close').click(function(e) {
        e.preventDefault();

        var modal = $(this).closest('.modal');
        modal.removeClass('modal--anim');

        setTimeout(function() {
          modal.removeClass('modal--show');
          $('body').removeClass('block-scroll');
        }, 750);
      });

      // Datepickr sample
      $('.datepickr').flatpickr({
        locale: 'es',
        monthSelectorType: 'static',
        yearSelectorType: 'static',
        allowInput: true
      });

      $('.dropdown-box .header').on('click', function(e){
        $(this).closest('.dropdown-box').toggleClass('active');
        $(this).closest('.dropdown-box').find('.content').slideToggle(300);
      });
    }

    static loading () {
      $('body').addClass('loading-page');
    }

    static endLoading () {
      $('body').removeClass('loading-page');
    }

    // static restartWow() {
    //     this._wow = new WOW({
    //         boxClass: 'wow',
    //         offset: 50,
    //         mobile: false,
    //         live: true
    //     });

    //     this._wow.init();
    // }
}

export default App;
